'use client'
import { Outlet } from 'react-router-dom'
import { Image, usePathname, useTranslations } from '@/lib/next-shim'
import { Link } from '@/lib/i18n/settings'

import { AppBar, Toolbar } from '@/components/external/material'
import { LanguageSwitcher } from '@/shared/ui/LanguageSwitcher'

import logoGif from '@/assets/img/logo.gif'
import { shouldUseCustomBranding } from '@/utils/landing-variant'
import { getEnv } from '@/lib/env'

type AuthLayoutProps = {
  children?: React.ReactNode
}

export function AuthLayout({ children }: AuthLayoutProps) {
  const pathname = usePathname()
  const t = useTranslations()
  const isReportLostDevicePage = pathname === '/report-lost-device'
  const isCustomBranded = shouldUseCustomBranding()
  const brandLogo = getEnv('NEXT_PUBLIC_BRAND_LOGO', '')
  const brandName = getEnv('NEXT_PUBLIC_BRAND_NAME', 'Medconnect Platform')

  return (
    <div className="h-full flex flex-col">
      <AppBar className="bg-white h-[60px] border-0 border-b border-solid border-gray-200 shadow-none">
        <Toolbar className="h-full sm:min-h-full">
          <div>
            <Link className="flex items-center justify-center" href="/">
              {isCustomBranded && brandLogo ? (
                <Image alt={brandName} src={brandLogo} width={107} height={60} className="h-16 w-auto object-contain" />
              ) : (
                <Image alt="logo" src={logoGif} width={107} height={60} className="h-16 w-auto" />
              )}
            </Link>
          </div>
          <div className="flex-1" />
          <div className="hidden md:block">
            <LanguageSwitcher />
          </div>
          <div className="block md:hidden">
            <LanguageSwitcher isMobile />
          </div>
        </Toolbar>
      </AppBar>
      <div className="flex-1 mt-[60px]">{children || <Outlet />}</div>
      {!isReportLostDevicePage && (
        <footer className="border-0 border-t border-solid border-gray-200 py-3 text-center">
          <Link className="text-sm text-gray-500 underline" href="/report-lost-device">
            {t('page.Landing.reportLostDevice')}
          </Link>
        </footer>
      )}
    </div>
  )
}
